import { fromJS } from 'immutable';
import { CALL_STATUS, SET_CALLBACKS_STATUS } from '@instructure/quiz-common';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromJS({});
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CALL_STATUS:
      return state.setIn([action.payload.call, 'requestStatus'], action.payload.status);
    case SET_CALLBACKS_STATUS:
      return state.setIn([action.payload.call, 'callbackStatus'], action.payload.status);
    default:
      return state;
  }
});